import { DefaultState, DropdownItem } from 'store/types';

export const GET_TYPES_FOR_FILTER_REQUEST = 'GET_TYPES_FOR_FILTER_REQUEST';
export const GET_TYPES_FOR_FILTER_SUCCESS = 'GET_TYPES_FOR_FILTER_SUCCESS';
export const GET_TYPES_FOR_FILTER_FAILURE = 'GET_TYPES_FOR_FILTER_FAILURE';

export interface GetTypesForFilterData {
  rows: DropdownItem[];
  totalCount: number;
}

export type GetTypesForFilterState = DefaultState & {
  contents?: GetTypesForFilterData;
};

interface ReadGetTypesForFilterRequest {
  type: typeof GET_TYPES_FOR_FILTER_REQUEST;
};

interface ReadGetTypesForFilterSuccess {
  type: typeof GET_TYPES_FOR_FILTER_SUCCESS,
  contents: GetTypesForFilterData;
}

interface ReadGetTypesForFilterFailure {
  type: typeof GET_TYPES_FOR_FILTER_FAILURE;
}

export type GetTypesForFilterActionTypes = ReadGetTypesForFilterRequest | ReadGetTypesForFilterSuccess | ReadGetTypesForFilterFailure;
